import React, { useCallback } from 'react';
import FormInput from 'components/Input/FormInput';

interface IRestrictionQrValueField {
	changeRestrictionQrValue: (value: string) => void;
}

const RestrictionQrValueField: React.FC<IRestrictionQrValueField> = ({ changeRestrictionQrValue }) => {
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			e.target.maxLength = 100;
			changeRestrictionQrValue(e.target.value);
			return e.target.value;
		},
		[changeRestrictionQrValue],
	);

	return (
		<FormInput
			testId="RestrictionQrValueField"
			name="restrictionQrValue"
			label="QRChatBotCodeLabel"
			getValueFromEvent={handleChange}
		/>
	);
};

export default React.memo(RestrictionQrValueField);
